import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class MachineChangeTrackService {
  public machineChangeTrack: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  //     true
  constructor() {}
}
